import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { LARGE_DL_MEMBER_COUNT } from '../constants';
import { isDLOrGroup } from './isDLOrGroup';

export function getGroupsAndSmallDLs(
    recipientInfo: SharingTipRecipientInfo[],
    shouldLookForMailboxType: boolean
): SharingTipRecipientInfo[] {
    const isDlOrGroup = (info: SharingTipRecipientInfo): boolean => {
        const isDlOrGroup = shouldLookForMailboxType
            ? isDLOrGroup(info.recipient.persona.EmailAddress.MailboxType)
            : info.totalMemberCount > 1;
        const isSmall = info.totalMemberCount <= LARGE_DL_MEMBER_COUNT;

        return isDlOrGroup && isSmall;
    };

    return recipientInfo.filter(info => isDlOrGroup(info));
}
